<template>
  <div>
    <b-card no-body>
      <b-card-header>
        <b-card-title>KIB C - Fase Desktop</b-card-title>
        <b-card-title class="text-primary">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="secondary"
            class="btn-icon"
            size="sm"
            :to="{ name: 'dataInformasi' }"
          >
            <feather-icon icon="ArrowLeftIcon" />
          </b-button>
        </b-card-title>
      </b-card-header>

      <b-card-body>
        <b-form
          class="needs-validation"
          @submit.prevent="submitForm"
        >
          <b-form-row>
            <b-col
              md="10"
              offset-md="1"
            >
              <b-form-group
                label="Kode Lokasi"
                label-for="kodeLokasi"
              >
                <b-form-input
                  id="kodeLokasi"
                  v-model="kodeLokasi"
                  disabled
                />
              </b-form-group>

              <b-form-group
                label="KIB"
                label-for="kib"
              >
                <b-form-input
                  id="kib"
                  v-model="kib"
                  disabled
                />
              </b-form-group>

              <b-form-group
                label="Kode Barang"
                label-for="kodeBarang"
              >
                <b-form-input
                  id="kodeBarang"
                  v-model="kodeBarang"
                  disabled
                />
              </b-form-group>

              <b-form-group
                label="Nama Barang"
                label-for="namaBarang"
              >
                <b-form-input
                  id="namaBarang"
                  v-model="nabar"
                  disabled
                />
              </b-form-group>

              <b-form-group
                label="Kode Register Barang"
                label-for="kodeRegisterBarang"
              >
                <b-form-input
                  id="kodeRegisterBarang"
                  v-model="kodeRegisterBarang"
                  disabled
                />
              </b-form-group>

              <b-form-group
                label="Nilai Perolehan"
                label-for="nilaiPerolehan"
              >
                <b-form-input
                  id="nilaiPerolehan"
                  v-model="nilaiPerolehan"
                  disabled
                />
              </b-form-group>

              <b-form-group
                label="Tanggal Perolehan"
                label-for="tahunPerolehan"
              >
                <b-form-input
                  id="tahunPerolehan"
                  v-model="tahunPerolehan"
                  disabled
                />
              </b-form-group>

              <b-form-group
                label="1. Kode Barang"
                label-for="kodeRegisterBarang"
              >
                <b-form-radio
                  v-model="kesesuaianKodeBarang"
                  value="1"
                  disabled
                >
                  Sesuai Dengan Data Lama
                </b-form-radio>
                <b-form-radio
                  v-model="kesesuaianKodeBarang"
                  value="0"
                  disabled
                >
                  Tidak Sesuai Dengan Data Lama
                </b-form-radio>

                <b-col
                  v-if="kesesuaianKodeBarang === '0'"
                  cols="11"
                  offset-md="1"
                  class="mt-1 pr-0"
                >
                  <b-form-group
                    label="KIB Seharusnya"
                    label-for="kibSeharusnya"
                  >
                    <b-form-input
                      v-model="kibSeharusnya"
                      disabled
                    />
                  </b-form-group>

                  <b-form-group
                    label="Kode Barang Yang Seharusnya"
                    label-for="kodeBarangSeharusnya"
                  >
                    <b-form-select
                      id="kodeBarangSeharusnya"
                      v-model="kodeBarangSeharusnya"
                      :options="dataKobar"
                      disabled
                    />
                  </b-form-group>
                </b-col>
              </b-form-group>

              <b-form-group
                label="2. Ukuran"
                label-for="ukuran"
              >
                <b-row>
                  <b-col cols="11">
                    <b-form-input
                      id="ukuran"
                      v-model="ukuran"
                      disabled
                    />
                  </b-col>
                  <b-col cols="1">
                    <label for="satuan">{{ satuan }}</label>
                  </b-col>
                  <b-col
                    cols="11"
                    offset-md="1"
                    class="mt-1"
                  >
                    <b-form-radio
                      v-model="kesesuaianUkuran"
                      value="1"
                      disabled
                    >
                      Sesuai Dengan Data Lama
                    </b-form-radio>
                    <b-form-radio
                      v-model="kesesuaianUkuran"
                      value="0"
                      disabled
                    >
                      Tidak Sesuai Dengan Data Lama
                    </b-form-radio>

                    <b-col
                      v-if="kesesuaianUkuran === '0'"
                      cols="11"
                      offset-md="1"
                      class="mt-1"
                    >
                      <label
                        for="ukuranSeharusnya"
                        class="d-block"
                      >Ukuran Seharusnya
                        <small class="text-warning">Wajib mengacu pada dokumen yang dapat
                          dipertanggungjawabkan</small></label>
                      <b-row>
                        <b-col cols="11">
                          <b-form-input
                            id="ukuranSeharusnya"
                            v-model="ukuranSeharusnya"
                            disabled
                          />
                        </b-col>
                        <b-col cols="1">
                          <label for="satuan">{{ satuanSeharusnya }}</label>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-col>
                </b-row>
              </b-form-group>

              <label
                for="namaSpesifikasiBarang"
                class="d-block col-form-label-lg pb-0 pt-0"
              >
                3. Nama Spesifikasi Barang
                <feather-icon
                  v-b-tooltip.hover
                  icon="AlertCircleIcon"
                  class="text-warning"
                  title="Diisi dengan nama spesifikasi barang milik daerah berupa nama gedung atau bangunan tersebut. Contoh: Gedung Sekolah SMAN 51 Jakarta Timur"
                />
              </label>
              <b-form-input
                id="namaSpesifikasiBarang"
                v-model="namaSpesifikasiBarang"
                disabled
              />

              <b-form-group
                label="4. Alamat"
                label-for="alamat"
              >
                <b-form-textarea
                  id="alamat"
                  v-model="alamat"
                  disabled
                />

                <b-col
                  cols="11"
                  offset-md="1"
                  class="mt-1 pr-0"
                >
                  <b-form-group
                    label="Provinsi"
                    label-for="provinsi"
                    class="mt-1"
                  >
                    <b-form-select
                      id="provinsi"
                      v-model="provinsi"
                      :options="dataProvinsi"
                      disabled
                    />
                  </b-form-group>

                  <b-form-group
                    label="Kabupaten/Kota"
                    label-for="kabKota"
                    class="mt-1"
                  >
                    <b-form-select
                      id="kabKota"
                      v-model="kabKota"
                      :options="dataKabKota"
                      disabled
                    />
                  </b-form-group>

                  <b-form-group
                    label="Kecamatan"
                    label-for="kecamatan"
                  >
                    <b-form-select
                      id="kecamatan"
                      v-model="kecamatan"
                      :options="dataKecamatan"
                      disabled
                    />
                  </b-form-group>
                  <b-form-group
                    label="Kelurahan"
                    label-for="kelurahan"
                  >
                    <b-form-select
                      id="kelurahan"
                      v-model="kelurahan"
                      :options="dataKelurahan"
                      disabled
                    />
                  </b-form-group>
                  <b-form-group
                    label="Jalan"
                    label-for="jalan"
                  >
                    <b-form-input
                      id="jalan"
                      v-model="jalan"
                      disabled
                    />
                  </b-form-group>
                  <b-row>
                    <b-col cols="2">
                      <b-form-group
                        label="No"
                        label-for="noAlamat"
                      >
                        <b-form-input
                          id="noAlamat"
                          v-model="noAlamat"
                          disabled
                        />
                      </b-form-group>
                    </b-col>
                    <b-col cols="2">
                      <b-form-group
                        label="RT"
                        label-for="rt"
                      >
                        <b-form-input
                          id="rt"
                          v-model="rt"
                          disabled
                        />
                      </b-form-group>
                    </b-col>
                    <b-col cols="2">
                      <b-form-group
                        label="RW"
                        label-for="rw"
                      >
                        <b-form-input
                          id="rw"
                          v-model="rw"
                          disabled
                        />
                      </b-form-group>
                    </b-col>
                    <b-col cols="6">
                      <b-form-group
                        label="Kode Pos"
                        label-for="kodePos"
                      >
                        <b-form-input
                          id="kodePos"
                          v-model="kodePos"
                          disabled
                        />
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-col>
              </b-form-group>

              <b-form-group
                label="5. Gedung Dan Bangunan Di Atas Tanah Milik"
                label-for="gedungBangunanTanahMilik"
              >
                <b-form-select
                  v-model="gedungBangunanTanahMilik"
                  :options="dataGedungBangunanTanahMilik"
                  disabled
                />
                <b-col
                  v-if="gedungBangunanTanahMilik === '1'"
                  cols="11"
                  offset-md="1"
                  class="mt-1 pr-0"
                >
                  <b-form-radio
                    v-model="isGedungBangunanTanahMilikTercatat"
                    value="1"
                    disabled
                  >
                    Sudah Tercatat
                  </b-form-radio>

                  <b-col
                    v-if="isGedungBangunanTanahMilikTercatat == '1'"
                    cols="11"
                    offset-md="1"
                    class="mt-1 pr-0"
                  >
                    <b-form-group
                      label="PD/UKPD"
                      label-for="gedungBangunanTanahMilikPdUkpd"
                    >
                      <b-form-select
                        v-model="gedungBangunanTanahMilikPdUkpd"
                        :options="dataPdUkpd"
                        disabled
                      />
                    </b-form-group>

                    <b-form-group
                      label="Kode Barang"
                      label-for="gedungBangunanTanahMilikKobar"
                    >
                      <b-form-input
                        id="gedungBangunanTanahMilikKobar"
                        v-model="gedungBangunanTanahMilikKobar"
                        :options="dataGedungBangunanTanahMilikKobar"
                        disabled
                      />
                    </b-form-group>

                    <b-form-group
                      label="Register"
                      label-for="gedungBangunanTanahMilikRegister"
                    >
                      <b-form-input
                        id="gedungBangunanTanahMilikRegister"
                        v-model="gedungBangunanTanahMilikRegister"
                        :options="dataGedungBangunanTanahMilikRegister"
                        disabled
                      />
                    </b-form-group>
                  </b-col>

                  <b-form-radio
                    v-model="isGedungBangunanTanahMilikTercatat"
                    value="0"
                    disabled
                  >
                    Belum Tercatat
                  </b-form-radio>

                  <b-col
                    v-if="isGedungBangunanTanahMilikTercatat == '0'"
                    cols="11"
                    offset-md="1"
                    class="mt-1 pr-0"
                  >
                    <b-form-group
                      label="Keterangan"
                      label-for="gedungBangunanTanahMilikKeterangan"
                      label-size="lg"
                      label-class="pb-0 pt-0"
                    >
                      <b-form-input
                        id="gedungBangunanTanahMilikKeterangan"
                        v-model="gedungBangunanTanahMilikKeterangan"
                        disabled
                      />
                    </b-form-group>
                  </b-col>
                </b-col>
                <b-col
                  v-if="
                    gedungBangunanTanahMilik === '2' ||
                      gedungBangunanTanahMilik === '3' ||
                      gedungBangunanTanahMilik === '4'
                  "
                  cols="11"
                  offset-md="1"
                  class="mt-1 pr-0"
                >
                  <b-form-group
                    label="Sebutkan"
                    label-for="gedungBangunanTanahMilikSebutkan"
                  >
                    <b-form-input
                      id="gedungBangunanTanahMilikSebutkan"
                      v-model="gedungBangunanTanahMilikSebutkan"
                      disabled
                    />
                  </b-form-group>
                </b-col>
              </b-form-group>

              <b-form-group
                label="6. Indikasi Tercatat Ganda"
                label-for="isIndikasiGanda"
              >
                <b-form-radio
                  v-model="isIndikasiGanda"
                  disabled
                  value="1"
                >
                  Terindikasi Tercatat Ganda Dengan
                </b-form-radio>
                <b-col
                  v-if="isIndikasiGanda === '1'"
                  cols="11"
                  offset-md="1"
                  class="mt-1 pr-0"
                >
                  <b-form-select
                    id="indikasiGandaDengan"
                    v-model="indikasiGandaDengan"
                    :options="dataIndikasiGandaDengan"
                    disabled
                  />

                  <b-col
                    cols="11"
                    offset-md="1"
                    class="mt-1 pr-0"
                  >
                    <b-form-group
                      v-if="
                        indikasiGandaDengan === '1' ||
                          indikasiGandaDengan === '2'
                      "
                      label="Sebutkan"
                      label-for="indikasiGandaSebutkan"
                    >
                      <b-form-input
                        id="indikasiGandaSebutkan"
                        v-model="indikasiGandaSebutkan"
                        disabled
                      />
                    </b-form-group>

                    <div v-if="indikasiGandaDengan === '3'">
                      <b-form-group
                        label=""
                        label-for="indikasiGandaPdUkpd"
                      >
                        <b-form-select
                          id="indikasiGandaPdUkpd"
                          v-model="indikasiGandaPdUkpd"
                          :options="dataPdUkpd"
                          disabled
                        />
                      </b-form-group>

                      <b-form-group
                        label="Kode Barang"
                        label-for="indikasiGandaKobar"
                      >
                        <b-form-input
                          id="indikasiGandaKobar"
                          v-model="indikasiGandaKobar"
                          disabled
                        />
                      </b-form-group>
                      <b-form-group
                        label="Register"
                        label-for="indikasiGandaRegister"
                      >
                        <b-form-select
                          id="indikasiGandaRegister"
                          v-model="indikasiGandaRegister"
                          :options="dataIndikasiGandaRegister"
                          disabled
                        />
                      </b-form-group>
                    </div>
                  </b-col>
                </b-col>
                <b-form-radio
                  v-model="isIndikasiGanda"
                  value="0"
                  disabled
                >
                  Tidak Tercatat Ganda
                </b-form-radio>
              </b-form-group>

              <b-form-group
                label="7. Indikasi Tercatat Gabungan (Gelondongan)"
                label-for="indikasiGabungan"
              >
                <b-form-input
                  id="indikasiGabungan"
                  v-model="indikasiGabungan"
                  disabled
                />

                <b-col
                  v-if="indikasiGabungan == 'Terindikasi Tercatat Gabungan'"
                  cols="11"
                  offset-md="1"
                  class="mt-1 pr-0"
                >
                  <b-form-group
                    label="Keterangan"
                    label-for="indikasiGabunganKeterangan"
                    label-size="lg"
                    label-class="pb-0 pt-0"
                  >
                    <b-form-input
                      id="indikasiGabunganKeterangan"
                      v-model="indikasiGabunganKeterangan"
                    />
                  </b-form-group>
                </b-col>
              </b-form-group>

              <b-form-group
                label="8. SK Penggunaan"
                label-for="skPenggunaan"
              >
                <b-form-radio
                  v-model="skPenggunaan"
                  value="1"
                  disabled
                >
                  Ada SK Penggunaan
                </b-form-radio>
                <b-col
                  v-if="skPenggunaan === '1'"
                  cols="11"
                  offset-md="1"
                  class="mt-1 pr-0"
                >
                  <b-form-group
                    label="Nomor SK Penggunaan"
                    label-for="nomorSkPenggunaan"
                  >
                    <b-form-input
                      id="nomorSkPenggunaan"
                      v-model="nomorSkPenggunaan"
                      disabled
                    />
                  </b-form-group>
                  <b-form-group
                    label="Tahun SK Penggunaan"
                    label-for="tahunSkPenggunaan"
                  >
                    <b-form-input
                      id="tahunSkPenggunaan"
                      v-model="tahunSkPenggunaan"
                      disabled
                    />
                  </b-form-group>
                </b-col>
                <b-form-radio
                  v-model="skPenggunaan"
                  disabled
                  value="0"
                >
                  Tidak Ada SK Penggunaan
                </b-form-radio>
              </b-form-group>

              <b-form-group
                label="9. Penggunaan"
                label-for="penggunaan"
              >
                <b-form-select
                  id="penggunaan"
                  v-model="penggunaan"
                  :options="dataPenggunaan"
                  disabled
                />

                <b-col
                  cols="11"
                  offset-md="1"
                  class="mt-1 pr-0"
                >
                  <!-- no. 2 -->
                  <b-form-group
                    v-if="penggunaan === '2'"
                    label="Digunakan Untuk"
                    label-for="digunakanUntuk"
                  >
                    <b-form-input
                      id="digunakanUntuk"
                      v-model="digunakanUntuk[0].value"
                      disabled
                    />
                  </b-form-group>

                  <!-- no. 3 -->
                  <div v-else-if="penggunaan === '3'">
                    <div
                      v-for="(item, index) of pdUkpd"
                      :key="index"
                    >
                      <b-form-group
                        label="PD/UKPD"
                        label-for="pdUkpd"
                      >
                        <b-form-select
                          v-model="item.value"
                          :options="dataPdUkpd"
                          disabled
                        />
                      </b-form-group>

                      <b-col
                        cols="11"
                        offset-md="1"
                        class="mt-1 pr-0"
                      >
                        <b-form-group
                          label="Digunakan Untuk"
                          label-for="digunakanUntuk"
                        >
                          <b-form-input
                            v-model="digunakanUntuk[index].value"
                            disabled
                          />
                        </b-form-group>
                      </b-col>
                    </div>
                  </div>

                  <!-- no. 4 -->
                  <div v-else-if="penggunaan === '4'">
                    <b-form-checkbox
                      v-model="digunakanBersama"
                      value="1"
                      disabled
                    >
                      PD/UKPD Lain
                    </b-form-checkbox>
                    <b-col
                      v-if="digunakanBersama.includes('1')"
                      cols="11"
                      offset-md="1"
                      class="mt-1 pr-0"
                    >
                      <div
                        v-for="(item, index) of pdUkpd"
                        :key="index"
                      >
                        <b-form-group
                          label="PD/UKPD"
                          label-for="pdUkpd"
                        >
                          <b-form-select
                            v-model="item.value"
                            :options="dataPdUkpd"
                            disabled
                          />
                        </b-form-group>
                        <b-col
                          cols="11"
                          offset-md="1"
                          class="mt-1 pr-0"
                        >
                          <b-form-group
                            label="Digunakan Untuk"
                            label-for="digunakanUntuk"
                          >
                            <b-form-input
                              id="digunakanUntuk"
                              v-model="digunakanUntuk[index].value"
                              disabled
                            />
                          </b-form-group>
                        </b-col>
                      </div>
                    </b-col>
                    <b-form-checkbox
                      v-model="digunakanBersama"
                      value="0"
                      disabled
                    >
                      Instansi / Pihak Lain
                    </b-form-checkbox>
                    <b-col
                      v-if="digunakanBersama.includes('0')"
                      cols="11"
                      offset-md="1"
                      class="mt-1 pr-0"
                    >
                      <div
                        v-for="(item, indexx) of pemanfaat"
                        :key="indexx + 'i'"
                      >
                        <b-form-group
                          label="Pemanfaat"
                          label-for="pemanfaat"
                        >
                          <b-form-select
                            v-model="item.value"
                            :options="dataPemanfaat"
                            disabled
                          />
                        </b-form-group>
                        <b-col
                          cols="11"
                          offset-md="1"
                          class="mt-1 pr-0"
                        >
                          <div v-if="pemanfaat[indexx].value === '1' || pemanfaat[indexx].value === '2'">
                            <b-form-group
                              label="Nama Pemanfaat"
                              label-for="namaPemanfaat"
                            >
                              <b-form-input
                                v-model="pemanfaat[indexx].namaPemanfaat"
                                disabled
                              />
                            </b-form-group>
                            <b-form-group
                              label="Dasar Penggunaan"
                              label-for="dasarPenggunaan"
                            >
                              <b-form-radio
                                v-model="pemanfaat[indexx].dasarPenggunaan"
                                disabled
                                value="1"
                              >
                                Ada Pinjam Pakai
                              </b-form-radio>
                              <b-form-radio
                                v-model="pemanfaat[indexx].dasarPenggunaan"
                                disabled
                                value="0"
                              >
                                Tidak Ada Pinjam Pakai
                              </b-form-radio>
                            </b-form-group>
                          </div>

                          <div v-if="pemanfaat[indexx].value === '3'">
                            <b-form-group
                              label="Nama Pemanfaat"
                              label-for="namaPemanfaat"
                            >
                              <b-form-input
                                v-model="pemanfaat[indexx].namaPemanfaat"
                                disabled
                              />
                            </b-form-group>
                            <b-form-group
                              label="Dasar Penggunaan"
                              label-for="kodeRegisterBarang"
                            >
                              <b-form-radio
                                v-model="pemanfaat[indexx].dasarPenggunaan"
                                disabled
                                value="1"
                              >
                                Ada Dasar Penggunaan
                              </b-form-radio>

                              <b-col
                                v-if="pemanfaat[indexx].dasarPenggunaan === '1'"
                                cols="11"
                                offset-md="1"
                              >
                                <b-form-radio
                                  v-model="
                                    pemanfaat[indexx].dasarPenggunaanTipe
                                  "
                                  disabled
                                  value="6"
                                >
                                  Sewa
                                </b-form-radio>
                                <b-form-radio
                                  v-model="
                                    pemanfaat[indexx].dasarPenggunaanTipe
                                  "
                                  disabled
                                  value="5"
                                >
                                  Pinjam Pakai
                                </b-form-radio>
                                <b-form-radio
                                  v-model="
                                    pemanfaat[indexx].dasarPenggunaanTipe
                                  "
                                  disabled
                                  value="3"
                                >
                                  Bangun Guna Serah
                                </b-form-radio>
                                <b-form-radio
                                  v-model="
                                    pemanfaat[indexx].dasarPenggunaanTipe
                                  "
                                  disabled
                                  value="4"
                                >
                                  Bangun Serah Guna
                                </b-form-radio>
                                <b-form-radio
                                  v-model="
                                    pemanfaat[indexx].dasarPenggunaanTipe
                                  "
                                  disabled
                                  value="7"
                                >
                                  KSP (Kerjasama Pemanfaatan)
                                </b-form-radio>
                                <b-form-radio
                                  v-model="
                                    pemanfaat[indexx].dasarPenggunaanTipe
                                  "
                                  disabled
                                  value="1"
                                >
                                  KSPI
                                </b-form-radio>
                              </b-col>

                              <b-form-radio
                                v-model="pemanfaat[indexx].dasarPenggunaan"
                                disabled
                                value="0"
                              >
                                Tidak Ada Dasar Penggunaan
                              </b-form-radio>
                            </b-form-group>
                          </div>
                        </b-col>
                      </div>
                    </b-col>
                  </div>

                  <!-- no. 5 -->
                  <div v-else-if="penggunaan === '5'">
                    <div
                      v-for="(item, indexx) of pemanfaat"
                      :key="indexx + 'i'"
                    >
                      <b-form-group
                        label="Pemanfaat"
                        label-for="pemanfaat"
                      >
                        <b-form-select
                          v-model="item.value"
                          :options="dataPemanfaat"
                          disabled
                        />
                      </b-form-group>
                      <b-col
                        cols="11"
                        offset-md="1"
                        class="mt-1 pr-0"
                      >
                        <div v-if="pemanfaat[indexx].value === '1' || pemanfaat[indexx].value === '2'">
                          <b-form-group
                            label="Nama Pemanfaat"
                            label-for="namaPemanfaat"
                          >
                            <b-form-input
                              v-model="pemanfaat[indexx].namaPemanfaat"
                              disabled
                            />
                          </b-form-group>
                          <b-form-group
                            label="Dasar Penggunaan"
                            label-for="dasarPenggunaan"
                          >
                            <b-form-radio
                              v-model="pemanfaat[indexx].dasarPenggunaan"
                              disabled
                              value="1"
                            >
                              Ada Pinjam Pakai
                            </b-form-radio>
                            <b-form-radio
                              v-model="pemanfaat[indexx].dasarPenggunaan"
                              disabled
                              value="0"
                            >
                              Tidak Ada Pinjam Pakai
                            </b-form-radio>
                          </b-form-group>
                        </div>

                        <div v-if="pemanfaat[indexx].value === '3'">
                          <b-form-group
                            label="Nama Pemanfaat"
                            label-for="namaPemanfaat"
                          >
                            <b-form-input
                              v-model="pemanfaat[indexx].namaPemanfaat"
                              disabled
                            />
                          </b-form-group>
                          <b-form-group
                            label="Dasar Penggunaan"
                            label-for="kodeRegisterBarang"
                          >
                            <b-form-radio
                              v-model="pemanfaat[indexx].dasarPenggunaan"
                              disabled
                              value="1"
                            >
                              Ada Dasar Penggunaan
                            </b-form-radio>

                            <b-col
                              v-if="pemanfaat[indexx].dasarPenggunaan === '1'"
                              cols="11"
                              offset-md="1"
                            >
                              <b-form-radio
                                v-model="pemanfaat[indexx].dasarPenggunaanTipe"
                                disabled
                                value="6"
                              >
                                Sewa
                              </b-form-radio>
                              <b-form-radio
                                v-model="pemanfaat[indexx].dasarPenggunaanTipe"
                                disabled
                                value="5"
                              >
                                Pinjam Pakai
                              </b-form-radio>
                              <b-form-radio
                                v-model="pemanfaat[indexx].dasarPenggunaanTipe"
                                disabled
                                value="3"
                              >
                                Bangun Guna Serah
                              </b-form-radio>
                              <b-form-radio
                                v-model="pemanfaat[indexx].dasarPenggunaanTipe"
                                disabled
                                value="4"
                              >
                                Bangun Serah Guna
                              </b-form-radio>
                              <b-form-radio
                                v-model="pemanfaat[indexx].dasarPenggunaanTipe"
                                disabled
                                value="7"
                              >
                                KSP (Kerjasama Pemanfaatan)
                              </b-form-radio>
                              <b-form-radio
                                v-model="pemanfaat[indexx].dasarPenggunaanTipe"
                                disabled
                                value="1"
                              >
                                KSPI
                              </b-form-radio>
                            </b-col>

                            <b-form-radio
                              v-model="pemanfaat[indexx].dasarPenggunaan"
                              disabled
                              value="0"
                            >
                              Tidak Ada Dasar Penggunaan
                            </b-form-radio>
                          </b-form-group>
                        </div>
                      </b-col>
                    </div>
                  </div>
                </b-col>
              </b-form-group>

              <b-form-group
                label="10. Apakah Bangunan Merupakan Bangunan Bertingkat ?"
                label-for="kodeRegisterBarang"
              >
                <b-form-radio
                  v-model="isBertingkat"
                  value="0"
                  disabled
                >
                  Tidak Bertingkat
                </b-form-radio>
                <b-form-radio
                  v-model="isBertingkat"
                  value="1"
                  disabled
                >
                  Ya, Bertingkat
                  <small class="text-warning">Bertingkat 1 Lantai adalah bangunan yang memiliki bangunan
                    1 tingkat di atas lantai dasar, tidak termasuk
                    rooftop</small>
                </b-form-radio>

                <b-col
                  v-if="isBertingkat === '1'"
                  cols="11"
                  offset-md="1"
                  class="mt-1 pr-0"
                >
                  <b-form-input
                    id="bertingkatSeharusnya"
                    v-model="bertingkatSeharusnya"
                    disabled
                  />
                </b-col>
              </b-form-group>

              <b-form-group
                label="11. Potensi Pemanfaatan"
                label-for="potensiPemanfaatan"
              >
                <b-col
                  cols="11"
                  offset-md="1"
                  class="mt-1 pr-0"
                >
                  <b-form-group
                    label="a. Apakah Terdapat Lantai Yang Tidak Digunakan ?"
                    label-for="isLantaiDigunakan"
                  >
                    <b-form-radio
                      v-model="isLantaiDigunakan"
                      value="1"
                      disabled
                    >
                      Ya
                    </b-form-radio>
                    <b-col
                      v-if="isLantaiDigunakan === '1'"
                      cols="11"
                      offset-md="1"
                      class="mt-1 pr-0"
                    >
                      <b-form-group
                        label="Jumlah Seluruh Lantai"
                        label-for="jumlahSeluruhLantai"
                      >
                        <b-form-input
                          id="jumlahSeluruhLantai"
                          v-model="jumlahSeluruhLantai"
                          disabled
                        />
                      </b-form-group>
                      <b-form-group
                        label="Jumlah Lantai Yang Digunakan"
                        label-for="jumlahLantaiDigunakan"
                      >
                        <b-form-input
                          id="jumlahLantaiDigunakan"
                          v-model="jumlahLantaiDigunakan"
                          disabled
                        />
                      </b-form-group>
                      <label
                        for="jumlahLantaiTidakDigunakan"
                        class="d-block col-form-label-lg pb-0 pt-0"
                      >
                        Jumlah Lantai Yang Tidak Digunakan
                        <feather-icon
                          v-b-tooltip.hover
                          icon="AlertCircleIcon"
                          class="text-warning"
                          title="Lantai tidak digunakan apabila penggunaan lantai kurang dari 50% dari total luas lantai"
                        />
                      </label>
                      <b-form-input
                        id="jumlahLantaiTidakDigunakan"
                        v-model="jumlahLantaiTidakDigunakan"
                        disabled
                      />
                    </b-col>
                    <b-form-radio
                      v-model="isLantaiDigunakan"
                      value="0"
                      disabled
                    >
                      Tidak
                    </b-form-radio>
                  </b-form-group>

                  <b-form-group
                    label="b. Atap Beton"
                    label-for="isAtapBeton"
                  >
                    <b-form-radio
                      v-model="isAtapBeton"
                      value="1"
                      disabled
                    >
                      Ada (Memiliki Atap Beton)
                    </b-form-radio>
                    <b-col
                      v-if="isAtapBeton === '1'"
                      cols="11"
                      offset-md="1"
                    >
                      <b-form-radio
                        v-model="isAtapBetonIsDigunakan"
                        value="1"
                        disabled
                      >
                        Digunakan
                        <feather-icon
                          v-b-tooltip.hover
                          icon="AlertCircleIcon"
                          class="text-warning"
                          title="Atap beton adalah ruang datar sebagai penutup bagian atas gedung dan bangunan yang dibangun menggunakan beban dan/atau campuran beton"
                        />
                      </b-form-radio>
                      <b-col
                        v-if="
                          isAtapBeton === '1' && isAtapBetonIsDigunakan === '1'
                        "
                        cols="11"
                        offset-md="1"
                        class="mt-1 pr-0"
                      >
                        <b-form-group
                          label="Digunakan Untuk"
                          label-for="atapBetonDigunakan"
                        >
                          <b-form-input
                            id="atapBetonDigunakan"
                            v-model="atapBetonDigunakan"
                            disabled
                          />
                        </b-form-group>
                      </b-col>
                      <b-form-radio
                        v-model="isAtapBetonIsDigunakan"
                        value="0"
                        disabled
                      >
                        Tidak Digunakan
                      </b-form-radio>
                    </b-col>
                    <b-form-radio
                      v-model="isAtapBeton"
                      value="0"
                      disabled
                    >
                      Tidak Ada Atap Beton
                    </b-form-radio>
                  </b-form-group>

                  <b-form-group
                    label="c. Basement"
                    label-for="isBasement"
                  >
                    <b-form-radio
                      v-model="isBasement"
                      value="1"
                      disabled
                    >
                      Ada (Memiliki Basement)
                    </b-form-radio>
                    <b-col
                      v-if="isBasement === '1'"
                      cols="11"
                      offset-md="1"
                    >
                      <b-form-radio
                        v-model="isBasementIsDigunakan"
                        value="1"
                        disabled
                      >
                        Digunakan
                      </b-form-radio>
                      <b-col
                        v-if="
                          isBasement === '1' && isBasementIsDigunakan === '1'
                        "
                        cols="11"
                        offset-md="1"
                        class="mt-1 pr-0"
                      >
                        <b-form-group
                          label="Digunakan Untuk"
                          label-for="basementDigunakan"
                        >
                          <b-form-input
                            id="basementDigunakan"
                            v-model="basementDigunakan"
                            disabled
                          />
                        </b-form-group>
                      </b-col>
                      <b-form-radio
                        v-model="isBasementIsDigunakan"
                        value="0"
                        disabled
                      >
                        Tidak Digunakan
                      </b-form-radio>
                    </b-col>
                    <b-form-radio
                      v-model="isBasement"
                      value="0"
                      disabled
                    >
                      Tidak Ada Basement
                    </b-form-radio>
                  </b-form-group>

                  <b-form-group
                    label="d. Halaman / Taman"
                    label-for="isHalamanUtama"
                  >
                    <b-form-radio
                      v-model="isHalamanUtama"
                      value="1"
                      disabled
                    >
                      Ada (Memiliki Halaman / Utama)
                    </b-form-radio>
                    <b-col
                      v-if="isHalamanUtama === '1'"
                      cols="11"
                      offset-md="1"
                      class="mt-1 pr-0"
                    >
                      <b-form-radio
                        v-model="isHalamanUtamaIsDigunakan"
                        value="1"
                        disabled
                      >
                        Digunakan
                      </b-form-radio>
                      <b-col
                        v-if="
                          isHalamanUtama === '1' &&
                            isHalamanUtamaIsDigunakan === '1'
                        "
                        cols="11"
                        offset-md="1"
                        class="mt-1 pr-0"
                      >
                        <b-form-group
                          label="Digunakan Untuk"
                          label-for="halamanUtamaDigunakan"
                        >
                          <b-form-input
                            id="halamanUtamaDigunakan"
                            v-model="halamanUtamaDigunakan"
                            disabled
                          />
                        </b-form-group>
                      </b-col>
                      <b-form-radio
                        v-model="isHalamanUtamaIsDigunakan"
                        value="0"
                        disabled
                      >
                        Tidak Digunakan
                      </b-form-radio>
                    </b-col>
                    <b-form-radio
                      v-model="isHalamanUtama"
                      value="0"
                      disabled
                    >
                      Tidak Ada Halaman / Utama
                    </b-form-radio>
                  </b-form-group>
                </b-col>
              </b-form-group>

              <label
                for="nilaiStrategisBMD"
                class="d-block col-form-label-lg pb-0 pt-0"
              >
                12. Nilai Strategis BMD
                <feather-icon
                  v-b-tooltip.hover
                  icon="AlertCircleIcon"
                  class="text-warning"
                  title="Memiliki nilai strategis apabila memakai satu atau lebih dari kriteria berikut: lokasi mudah diakses kendaraan roda 4, terdapat lahan parkir memadai, lingkungan nyaman dan tersedianya sumber daya"
                />
              </label>

              <b-form-select
                id="nilaiStrategisBMD"
                v-model="nilaiStrategisBMD"
                :options="dataNilaiStrategisBMD"
                disabled
              />

              <b-col
                v-if="nilaiStrategisBMD === '1'"
                cols="11"
                offset-md="1"
                class="mt-1 pr-0"
              >
                <b-form-checkbox
                  v-model="memilikiNilaiStrategis"
                  value="3"
                  disabled
                >
                  Lokasi mudah diakses kendaraan roda 4, memiliki jalan dua arah
                  dengan lebar jalan kurang lebih 8m
                  <feather-icon
                    v-b-tooltip.hover
                    icon="AlertCircleIcon"
                    class="text-warning"
                    title="Jalan akses menuju lokasi gedung dan bangunan memiliki luasan yang cukup untuk dilewati kendaraan roda 4 dua arah"
                  />
                </b-form-checkbox>
                <b-form-checkbox
                  v-model="memilikiNilaiStrategis"
                  value="2"
                  disabled
                >
                  Terdapat lahan parkir yang memadai (tidak pernah kesulitan
                  dalam memarkirkan kendaraan)
                  <feather-icon
                    v-b-tooltip.hover
                    icon="AlertCircleIcon"
                    class="text-warning"
                    title="Gedung dan bangunan memiliki lahan parkir yang bisa menampung minimal 5"
                  />
                </b-form-checkbox>
                <b-form-checkbox
                  v-model="memilikiNilaiStrategis"
                  value="1"
                  disabled
                >
                  Lingkungan strategis dekat dengan pusat bisnis atau fasilitas
                  publik
                  <feather-icon
                    v-b-tooltip.hover
                    icon="AlertCircleIcon"
                    class="text-warning"
                    title="Gedung dan bangunan berada pada lokasi yang strategis tanpa disertai gangguan berarti. Misalnya, dekat dengan pusat perbelanjaan atau tempat wisata"
                  />
                </b-form-checkbox>
                <b-form-checkbox
                  v-model="memilikiNilaiStrategis"
                  value="0"
                  disabled
                >
                  Tersedianya sumber daya (listrik, air dan layanan jaringan
                  internet)
                  <feather-icon
                    v-b-tooltip.hover
                    icon="AlertCircleIcon"
                    class="text-warning"
                    title="Tersedianya aliran listrik dengan kerusakan jaringan yang minimal, air mengalir dan/atau terjangkau jaringan provider internet"
                  />
                </b-form-checkbox>
              </b-col>

              <b-form-group
                label="13. Penguasaan Fisik"
                label-for="nilaiStrategisBMD"
              >
                <b-form-radio
                  v-model="pengamananFisik"
                  value="1"
                  disabled
                >
                  Fisik Dikuasai
                </b-form-radio>
                <b-col
                  v-if="pengamananFisik === '1'"
                  cols="11"
                  offset-md="1"
                  class="mt-1 pr-0"
                >
                  <b-form-radio
                    v-model="fisikDikuasai"
                    value="1"
                    disabled
                  >
                    Fisik dikuasai seluruh oleh Pemerintah Provinsi DKI Jakarta
                  </b-form-radio>
                  <b-form-radio
                    v-model="fisikDikuasai"
                    value="0"
                    disabled
                  >
                    Fisik dikuasai sebagian oleh pihak lain
                  </b-form-radio>
                  <b-col
                    v-if="pengamananFisik === '1' && fisikDikuasai === '0'"
                    cols="11"
                    offset-md="1"
                    class="mt-1 pr-0"
                  >
                    <b-form-group
                      label="Sebutkan"
                      label-for="fisikDikuasaiSebutkan"
                    >
                      <b-form-input
                        id="fisikDikuasaiSebutkan"
                        v-model="fisikDikuasaiSebutkan"
                        disabled
                      />
                    </b-form-group>
                  </b-col>
                </b-col>
                <b-form-radio
                  v-model="pengamananFisik"
                  value="0"
                  disabled
                >
                  Fisik Tidak Dikuasai (dikuasai seluruhnya oleh pihak lain)
                </b-form-radio>
                <b-col
                  v-if="pengamananFisik === '0'"
                  cols="11"
                  offset-md="1"
                  class="mt-1 pr-0"
                >
                  <b-form-group
                    label="Sebutkan"
                    label-for="fisikTidakDikuasaiSebutkan"
                  >
                    <b-form-input
                      id="fisikTidakDikuasaiSebutkan"
                      v-model="fisikTidakDikuasaiSebutkan"
                      disabled
                    />
                  </b-form-group>
                </b-col>
              </b-form-group>

              <label
                for="sengketaGedungBangunan"
                class="d-block col-form-label-lg pb-0 pt-0"
              >
                14. Sengketa Pada Gedung dan Bangunan
                <feather-icon
                  v-b-tooltip.hover
                  icon="AlertCircleIcon"
                  class="text-warning"
                  title="Gedung dan bangunan bersengketa apabila sudah ada gugatan di pengadilan atas gedung dan bangunan tersebut"
                />
              </label>
              <b-form-radio
                v-model="sengketaGedungBangunan"
                value="1"
                disabled
              >
                Ada Sengketa
              </b-form-radio>
              <b-form-radio
                v-model="sengketaGedungBangunan"
                value="0"
                disabled
              >
                Tidak Ada Sengketa
              </b-form-radio>

              <label
                for="ketAsetBersejarah"
                class="d-block col-form-label-lg pb-0 pt-1"
              >
                15. Keterangan Aset Bersejarah
                <feather-icon
                  v-b-tooltip.hover
                  icon="AlertCircleIcon"
                  class="text-warning"
                  title="BMD tergolong aset bersejarah apabila memiliki karakteristik sebagai berikut.
                    -Memiliki nilai kultural lingkungan pendidikan dan sejarahnya tidak mungkin secara penuh dilambangkan dengan nilai keuangan berdasarkan harga pasar;
                    -Peraturan dan hukum melarang atau membatasi secara ketat pelepasannya untuk dijual;
                    -Tidak mudah untuk diganti dan nilainya akan terus meningkat selama waktu berjalan walaupun kondisi fisiknya semakin menurun; dan
                    -Sulit untuk mengestimasikan masa manfaatnya terhadap beberapa kasus dapat mencapai ratusan tahun;"
                />
              </label>
              <b-form-radio
                v-model="ketAsetBersejarah"
                value="1"
                disabled
              >
                Ya, BMD merupakan aset bersejarah
              </b-form-radio>
              <b-form-radio
                v-model="ketAsetBersejarah"
                value="0"
                disabled
              >
                Tidak, BMD bukan merupakan aset bersejarah
              </b-form-radio>
            </b-col>
          </b-form-row>
        </b-form>
      </b-card-body>
    </b-card>

    <b-card
      v-if="
        $can('Validasi', 'dataInformasi') &&
          routeName == 'dataInformasiValidasi'
      "
      no-body
    >
      <b-card-header>
        <b-card-title>Verifikasi P3B</b-card-title>
      </b-card-header>

      <b-card-body>
        <b-form
          class="needs-validation"
          @submit.prevent="submitForm"
        >
          <b-form-row>
            <b-col
              md="10"
              offset-md="1"
            >
              <b-form-group
                label="Status Persetujuan"
                label-for="statusPersetujuan"
              >
                <b-row>
                  <b-col md="3">
                    <b-form-radio
                      v-model="v$.statusPersetujuan.$model"
                      value="1"
                      :state="validateState(v$.statusPersetujuan)"
                      :disabled="isShowInfo"
                    >
                      Setuju
                    </b-form-radio>
                  </b-col>
                  <b-col>
                    <b-form-radio
                      v-model="v$.statusPersetujuan.$model"
                      value="0"
                      :state="validateState(v$.statusPersetujuan)"
                    >
                      Dikembalikan
                    </b-form-radio>
                  </b-col>
                </b-row>
                <small
                  v-for="(error, index) of v$.statusPersetujuan.$errors"
                  :key="index"
                  class="text-danger"
                >
                  <span>{{ error.$message }}</span>
                </small>
              </b-form-group>

              <b-form-group
                v-if="statusPersetujuan === '0'"
                label="Catatan"
                label-for="catatan"
              >
                <b-form-textarea
                  id="catatan"
                  v-model="v$.catatan.$model"
                  :state="validateState(v$.catatan)"
                />
                <b-form-invalid-feedback
                  v-for="(error, index) of v$.catatan.$errors"
                  :key="index"
                >
                  <span v-if="error.$validator == 'checkCatatan'">
                    Catatan Harus di Isi Jika Dikembalikan
                  </span>
                  <span v-else>{{ error.$message }}</span>
                </b-form-invalid-feedback>
              </b-form-group>
              <b-col
                cols="12"
                class="text-right pr-0 pt-2"
              >
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  type="submit"
                  variant="primary"
                >
                  <div v-if="isSubmit">
                    <b-spinner small />
                    <span class="sr-only">Loading...</span>
                  </div>
                  <div v-else>
                    Validasi
                  </div>
                </b-button>
              </b-col>
            </b-col>
          </b-form-row>
        </b-form>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BForm,
  BFormRow,
  BCol,
  BFormInput,
  BFormValidFeedback,
  BFormInvalidFeedback,
  BCardHeader,
  BCardBody,
  BButton,
  BFormGroup,
  BCardTitle,
  BSpinner,
  BFormSelect,
  BTable,
  BRow,
  BFormTextarea,
} from 'bootstrap-vue'
import { required, helpers } from '@vuelidate/validators'
import useVuelidate from '@vuelidate/core'
import {
  ref,
  computed,
  watch,
  onUnmounted,
} from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
// import {generateYears, startYear, intThousand, setInputIntOnly, defaultYear} from '@/libs/helper'
import moment from 'moment'
import validasiKeberadaan from '@/composables/validasiKeberadaan'
import dataInformasi from '@/composables/dataInformasi'
import { intThousand } from '@/libs/helper'
import master from '@/composables/master'
import ToastificationContent from '@/views/dataInformasi/component/toast/ToastificationContent.vue'

export default {
  props: {
    alasanTidakAdaVal: String,
    alasanTidakAdaPVal: String,
    asetIndukVal: String,
    pdUkpdVal: String,
    kobarIndukVal: String,
    nabarIndukVal: String,
    registerBarangVal: String,
    alasanTidakAdaNoteVal: String,

    isShowUbahVal: Boolean,

    action: String,
    id: String,
  },
  setup(props, context) {
    const g = context.root

    let routeName = ref(g.$route.name)
    let isSubmit = ref(false)
    let tahunNow = ref(moment().format('YYYY'))

    //form name
    let kodeLokasi = ref('')
    let kib = ref('')
    let kodeBarang = ref('')
    let namaBarang = ref('')
    let kodeRegisterBarang = ref('')
    let nabar = ref('')
    let nilaiPerolehan = ref('')
    let tahunPerolehan = ref('')
    let satuan = ref('')
    let kesesuaianKodeBarang = ref('')
    let kibSeharusnya = ref('')
    let kodeBarangSeharusnya = ref('')
    let namaBarangSeharusnya = ref('')
    let ukuran = ref('')
    let kesesuaianUkuran = ref('')
    let ukuranSeharusnya = ref('')
    let satuanSeharusnya = ref('')
    let namaSpesifikasiBarang = ref('')
    let caraPerolehanPenerimaan = ref('')
    let isBertingkat = ref('')
    let bertingkatSeharusnya = ref('')
    let jumlahSeluruhLantai = ref('')
    let isLantaiDigunakan = ref('')
    let jumlahLantaiTidakDigunakan = ref('')
    let jumlahLantaiDigunakan = ref('')
    let jenisBeton = ref('')
    let kesesuaianBahan = ref('')
    let bahanSeharusnya = ref('')
    let skPenggunaan = ref('')
    let nomorSkPenggunaan = ref('')
    let tahunSkPenggunaan = ref('')
    let penggunaan = ref(null)
    let digunakanBersama = ref([])
    let digunakanUntuk = ref([])
    let pdUkpd = ref([])
    let pemanfaat = ref([
      {
        value: null,
        namaPemanfaat: '',
        dasarPenggunaan: '',
        dasarPenggunaanTipe: '',
      },
    ])
    let gedungBangunanTanahMilik = ref(null)
    let isGedungBangunanTanahMilikTercatat = ref(null)
    let gedungBangunanTanahMilikPdUkpd = ref(null)
    let gedungBangunanTanahMilikKobar = ref(null)
    let gedungBangunanTanahMilikRegister = ref(null)
    let gedungBangunanTanahMilikKeterangan = ref('')
    let gedungBangunanTanahMilikSebutkan = ref('')
    let alamat = ref('')
    let kesesuaianAlamat = ref('0')
    let provinsi = ref(null)
    let kabKota = ref(null)
    let kecamatan = ref(null)
    let kelurahan = ref(null)
    let jalan = ref('')
    let noAlamat = ref('')
    let rt = ref('')
    let rw = ref('')
    let kodePos = ref('')
    let isIndikasiGanda = ref('')
    let indikasiGandaDengan = ref(null)
    let indikasiGandaSebutkan = ref('')
    let indikasiGandaPdUkpd = ref(null)
    let indikasiGandaKobar = ref('')
    let indikasiGandaRegister = ref(null)
    let indikasiGabungan = ref(null)
    let indikasiGabunganKeterangan = ref(null)
    let isAtapBeton = ref(null)
    let isAtapBetonIsDigunakan = ref(null)
    let atapBetonDigunakan = ref('')
    let isBasement = ref(null)
    let isBasementIsDigunakan = ref(null)
    let basementDigunakan = ref('')
    let isHalamanUtama = ref(null)
    let isHalamanUtamaIsDigunakan = ref(null)
    let halamanUtamaDigunakan = ref('')
    let nilaiStrategisBMD = ref(null)
    let memilikiNilaiStrategis = ref([])
    let pengamananFisik = ref(null)
    let fisikDikuasai = ref(null)
    let fisikDikuasaiSebutkan = ref('')
    let fisikTidakDikuasaiSebutkan = ref(null)
    let sengketaGedungBangunan = ref(null)
    let ketAsetBersejarah = ref(null)

    let rekonKode = ref('')
    let rekonTahun = ref('')

    let catatan = ref('')
    let statusPersetujuan = ref(null)

    let dataKodeLokasi = ref([])
    let dataKib = ref([])
    let dataPdUkpd = ref([])
    let dataGedungBangunanTanahMilikRegister = ref([
      { text: '-- Pilih Salah Satu --', value: null },
    ])
    let dataGedungBangunanTanahMilikKobar = ref([
      { text: '-- Pilih Salah Satu --', value: null },
    ])
    let dataProvinsi = ref([{ value: null, text: '-- Pilih Salah Satu --' }])
    let dataKabKota = ref([{ value: null, text: '-- Pilih Salah Satu --' }])
    let dataKecamatan = ref([{ value: null, text: '-- Pilih Salah Satu --' }])
    let dataKelurahan = ref([{ value: null, text: '-- Pilih Salah Satu --' }])
    let dataIndikasiGandaPdUkpd = ref([])
    let dataIndikasiGandaRegister = ref([
      { text: '-- Pilih Salah Satu --', value: null },
    ])
    let dataKobar = ref([])
    let dataCaraPerolehanPenerimaan = ref([])

    let isShowUbah = ref(false)
    let isShowInfo = ref(false)

    watch(isShowInfo, () => {
      if (isShowInfo.value) {
        g.$toast(
          {
            component: ToastificationContent,
            props: {
              title: 'Perhatian',
              icon: 'BellIcon',
              text: 'Ada beberapa perubahan terkait form yg harus diisi pada mobile',
              variant: 'warning',
            },
          },
          {
            timeout: false,
            position: 'top-center',
          }
        )
      }
    })

    onUnmounted(() => {
      g.$toast.clear()
    })

    const getProvinsi = async () => {
      let resProvinsi = await master.getProvinsi(g)
      resProvinsi.unshift({ text: '-- Pilih Salah Satu --', value: null })
      dataProvinsi.value = resProvinsi
    };

    const getKabKota = async () => {
      let params = {
        provinsi: provinsi.value,
      }

      let resKota = await master.getKota(g, params)
      resKota.unshift({ text: '-- Pilih Salah Satu --', value: null })
      dataKabKota.value = resKota
    };

    const getKecamatan = async () => {
      let params = {
        provinsi: provinsi.value,
        kota: kabKota.value,
      }
      let resKecamatan = await master.getKecamatan(g, params)
      resKecamatan.unshift({ text: '-- Pilih Salah Satu --', value: null })
      dataKecamatan.value = resKecamatan
    };

    const getKelurahan = async () => {
      let params = {
        provinsi: provinsi.value,
        kota: kabKota.value,
        kecamatan: kecamatan.value,
      }
      let resKelurahan = await master.getKelurahan(g, params)
      resKelurahan.unshift({ text: '-- Pilih Salah Satu --', value: null })
      dataKelurahan.value = resKelurahan
    };

    const getNoReg = async (kib = '', kobar = '', kolok = '') => {
      let params = {
        kib,
        tahun_rekon: rekonTahun.value,
        kode_rekon: rekonKode.value,
        kobar,
        kolok,
      }

      let resNoReg = await master.getNoReg(g, params)
      resNoReg = resNoReg.rows?.map((data, i) => {
        return {
          text: data.noreg_108 + ' :: ' + data.ALAMAT,
          value: data.noreg_108,
        }
      })
      resNoReg?.unshift({ text: '-- Pilih Salah Satu --', value: null })
      // dataIndikasiGandaRegister.value = resNoReg
      return resNoReg
    };

    const getKobar = async (kobar = '', kolok = null, kib = '') => {
      let params = {
        kib,
        cari: kobar,
        kolok,
        length: 100000,
      }
      let resKobar = await master.getKobar(g, params)

      resKobar = resKobar.rows.map((data, i) => {
        return {
          text: `${data.kode} :: ${data.nama}`,
          value: data.kode,
          nama: data.nama,
          kodeSatuan: data.kodeSatuan,
        }
      })
      resKobar.unshift({ text: '-- Pilih Salah Satu --', value: null })
      return resKobar
      // dataKobar.value = resKobar
    };

    const getData = async () => {
      const response = await validasiKeberadaan.getBmdDetail(g, {
        id: props.id,
        username: g.$cookies.get('username'),
      })
      const { data, code } = response

      if (code == 200) {
        const {
          KOLOK,
          nama_pd_ukpd_siera,
          kib: kibVal,
          kobar_108,
          nabar_108,
          noreg_108,
          HARGA,
          SATUAN,
          TGLOLEH,
          UKURAN,
          BETON,
          ALAMAT,
          rekon_kode,
          rekon_tahun,
          status,
          di_validasi_sensus_note,
          di_m_kobar,
          di_m_kobar_a,
          di_m_nabar_a,
          di_m_ukuran,
          di_m_ukuran_a,
          di_cara_perolehan,
          di_m_bertingkat,
          di_m_bertingkat_a,
          di_m_lantai_tdk,
          di_m_lantai_tdk_all,
          di_m_lantai_tdk_use,
          di_m_lantai_tdk_not,
          di_m_beton,
          di_m_beton_a,
          di_m_sk_penggunaan,
          di_sk_penggunaan_tahun,
          di_sk_penggunaan_no,
          di_penggunaan,
          penggunaan_pihak_lain,
          penggunaan_opd,
          di_gedung_bangunan_diatas_tanah_milik,
          di_gedung_bangunan_diatas_tanah_milik_tercatat,
          di_gedung_bangunan_diatas_tanah_milik_sebut,
          di_m_alamat,
          di_kd_prop,
          di_kd_rayon,
          di_kd_kec,
          di_kd_kel,
          di_kodepos,
          di_jalan,
          di_no_jalan,
          di_rt,
          di_rw,
          di_indikasi_ganda,
          di_indikasi_ganda_dengan,
          di_indikasi_ganda_sebutkan,
          di_indikasi_ganda_opd,
          di_indikasi_ganda_kobar,
          di_indikasi_ganda_register,
          di_m_kobar_kib,
          di_gedung_bangunan_diatas_tanah_milik_opd,
          di_gedung_bangunan_diatas_tanah_milik_kobar,
          di_gedung_bangunan_diatas_tanah_milik_noreg,
          di_nm_spesifikasi_barang,
          di_indikasi_gabungan,
          di_pp_at_ada,
          di_pp_at_ada_digunakan,
          di_pp_at_ada_digunakan_oleh,
          di_pp_bm_ada,
          di_pp_bm_ada_digunakan,
          di_pp_bm_ada_digunakan_oleh,
          di_pp_ht_ada,
          di_pp_ht_ada_digunakan,
          di_pp_ht_ada_digunakan_oleh,
          di_nilai_stragtegis,
          di_nilai_stragtegis_child,
          di_pengamanan_fisik,
          di_pengamanan_fisik_child,
          di_pengamanan_fisik_note,
          di_sengketa,
          di_aset_bersejarah,
          di_indikasi_gabungan_keterangan,
        } = data
        if (!di_m_kobar || !di_kd_kel || !di_m_bertingkat)
          isShowInfo.value = true

        kodeLokasi.value = KOLOK + '::' + nama_pd_ukpd_siera
        kib.value = kibVal
        kodeBarang.value = kobar_108
        kodeRegisterBarang.value = noreg_108
        nabar.value = nabar_108
        nilaiPerolehan.value = intThousand(HARGA.toString().replace('.', ','))
        tahunPerolehan.value = TGLOLEH
        satuan.value = SATUAN
        kesesuaianKodeBarang.value = di_m_kobar
        kibSeharusnya.value = di_m_kobar_kib
        kodeBarangSeharusnya.value = di_m_kobar_a
        namaBarangSeharusnya.value = di_m_nabar_a
        ukuran.value = UKURAN?.toString().replace('.', ',')
        kesesuaianUkuran.value = di_m_ukuran
        ukuranSeharusnya.value = di_m_ukuran_a
        namaSpesifikasiBarang.value = di_nm_spesifikasi_barang
        caraPerolehanPenerimaan.value = di_cara_perolehan
        isBertingkat.value = di_m_bertingkat
        bertingkatSeharusnya.value = di_m_bertingkat_a
        isLantaiDigunakan.value = di_m_lantai_tdk
        jumlahSeluruhLantai.value = di_m_lantai_tdk_all
        jumlahLantaiTidakDigunakan.value = di_m_lantai_tdk_not
        jumlahLantaiDigunakan.value = di_m_lantai_tdk_use
        jenisBeton.value = BETON
        kesesuaianBahan.value = di_m_beton
        bahanSeharusnya.value = di_m_beton_a
        skPenggunaan.value = di_m_sk_penggunaan
        nomorSkPenggunaan.value = di_sk_penggunaan_no
        tahunSkPenggunaan.value = di_sk_penggunaan_tahun
        penggunaan.value = di_penggunaan

        if (penggunaan_opd) {
          if (penggunaan_opd.length > 0) {
            digunakanBersama.value.push('1')

            for (let i = 0; i < penggunaan_opd.length; i++) {
              const { di_penggunaan_opd, di_penggunaan_untuk } =
                penggunaan_opd[i]

              pdUkpd.value.push({ value: di_penggunaan_opd })
              digunakanUntuk.value.push({ value: di_penggunaan_untuk })
            }
          }
        }
        if (penggunaan_pihak_lain) {
          if (penggunaan_pihak_lain.length > 0) {
            digunakanBersama.value.push('0')

            pemanfaat.value = []
            for (let i = 0; i < penggunaan_pihak_lain.length; i++) {
              const {
                di_penggunaan_pemanfaat,
                di_penggunaan_pemanfaat_nama,
                di_penggunaan_pemanfaat_dasar,
                di_penggunaan_pemanfaat_dasar_type,
              } = penggunaan_pihak_lain[i]

              pemanfaat.value.push({
                value: di_penggunaan_pemanfaat,
                namaPemanfaat: di_penggunaan_pemanfaat_nama,
                dasarPenggunaan: di_penggunaan_pemanfaat_dasar,
                dasarPenggunaanTipe: di_penggunaan_pemanfaat_dasar_type,
              })
            }
          }
        }
        gedungBangunanTanahMilik.value = di_gedung_bangunan_diatas_tanah_milik
        if (di_gedung_bangunan_diatas_tanah_milik == 1) {
          isGedungBangunanTanahMilikTercatat.value =
            di_gedung_bangunan_diatas_tanah_milik_tercatat || '0'

          if (di_gedung_bangunan_diatas_tanah_milik_tercatat == 1) {
            gedungBangunanTanahMilikPdUkpd.value =
              di_gedung_bangunan_diatas_tanah_milik_opd
            gedungBangunanTanahMilikKobar.value =
              di_gedung_bangunan_diatas_tanah_milik_kobar
            gedungBangunanTanahMilikRegister.value =
              di_gedung_bangunan_diatas_tanah_milik_noreg
          } else
            gedungBangunanTanahMilikKeterangan.value =
              di_gedung_bangunan_diatas_tanah_milik_sebut
        } else if (
          di_gedung_bangunan_diatas_tanah_milik == 2 ||
          di_gedung_bangunan_diatas_tanah_milik == 3 ||
          di_gedung_bangunan_diatas_tanah_milik == 4
        )
          gedungBangunanTanahMilikSebutkan.value =
            di_gedung_bangunan_diatas_tanah_milik_sebut

        alamat.value = ALAMAT
        kesesuaianAlamat.value = di_m_alamat
        provinsi.value = di_kd_prop
        kabKota.value = di_kd_rayon
        kecamatan.value = di_kd_kec
        kelurahan.value = di_kd_kel
        jalan.value = di_jalan
        noAlamat.value = di_no_jalan
        rt.value = di_rt
        rw.value = di_rw
        kodePos.value = di_kodepos
        isIndikasiGanda.value = di_indikasi_ganda
        indikasiGandaDengan.value = di_indikasi_ganda_dengan
        indikasiGandaSebutkan.value = di_indikasi_ganda_sebutkan
        indikasiGandaPdUkpd.value = di_indikasi_ganda_opd
        indikasiGandaKobar.value = di_indikasi_ganda_kobar
        indikasiGandaRegister.value = di_indikasi_ganda_register
        indikasiGabungan.value =
          di_indikasi_gabungan === '1'
            ? 'Terindikasi Tercatat Gabungan'
            : 'Tidak Tercatat Gabungan'

        if (di_indikasi_gabungan)
          indikasiGabunganKeterangan.value = di_indikasi_gabungan_keterangan
        isAtapBeton.value = di_pp_at_ada
        isAtapBetonIsDigunakan.value = di_pp_at_ada_digunakan
        atapBetonDigunakan.value = di_pp_at_ada_digunakan_oleh
        isBasement.value = di_pp_bm_ada
        isBasementIsDigunakan.value = di_pp_bm_ada_digunakan
        basementDigunakan.value = di_pp_bm_ada_digunakan_oleh
        isHalamanUtama.value = di_pp_ht_ada
        isHalamanUtamaIsDigunakan.value = di_pp_ht_ada_digunakan
        halamanUtamaDigunakan.value = di_pp_ht_ada_digunakan_oleh
        nilaiStrategisBMD.value = di_nilai_stragtegis
        memilikiNilaiStrategis.value = di_nilai_stragtegis_child
          ? di_nilai_stragtegis_child
          : []
        pengamananFisik.value = di_pengamanan_fisik
        fisikDikuasai.value = di_pengamanan_fisik_child
        fisikDikuasaiSebutkan.value = di_pengamanan_fisik_note
        fisikTidakDikuasaiSebutkan.value = di_pengamanan_fisik_note
        sengketaGedungBangunan.value = di_sengketa
        ketAsetBersejarah.value = di_aset_bersejarah

        rekonKode.value = rekon_kode
        rekonTahun.value = rekon_tahun

        statusPersetujuan.value = status == 6 ? '0' : status >= 7 ? '1' : null
        catatan.value = di_validasi_sensus_note

        getProvinsi()
        getKabKota()
        getKecamatan()
        getKelurahan()
        dataKobar.value = await getKobar(
          '',
          null,
          kibSeharusnya.value ? kibSeharusnya.value : kib.value
        )

        let index
        if (di_m_kobar_a) {
          index = dataKobar.value.findIndex(
            (item) => item.value == di_m_kobar_a
          )

          satuanSeharusnya.value =
            index >= 0 ? dataKobar.value[index].kodeSatuan : SATUAN
        } else satuanSeharusnya.value = SATUAN

        dataIndikasiGandaRegister.value = await getNoReg(
          kibSeharusnya.value ? kibSeharusnya.value : kib.value,
          indikasiGandaKobar.value,
          indikasiGandaPdUkpd.value
        )

        dataGedungBangunanTanahMilikRegister.value = await getNoReg(
          'A',
          di_gedung_bangunan_diatas_tanah_milik_kobar ?? null,
          di_gedung_bangunan_diatas_tanah_milik_opd
        )
        dataGedungBangunanTanahMilikKobar.value = await getKobar(
          '',
          di_gedung_bangunan_diatas_tanah_milik_opd,
          'A'
        )
      }

      isShowUbah.value = false
    };

    getData()

    const checkCatatan = (val) => {
      if (!val && statusPersetujuan.value == 0) return false

      return true
    };

    // validation
    const requiredMsg = 'tidak boleh kosong'
    const $externalResults = ref({})
    const rules = computed(() => ({
      statusPersetujuan: {
        required: helpers.withMessage(
          'Status Persetujuan ' + requiredMsg,
          required
        ),
      },
      catatan: {
        checkCatatan,
      },
    }))

    const v$ = useVuelidate(
      rules,
      { statusPersetujuan, catatan },
      { $externalResults, $autoDirty: true }
    )

    const submitForm = async () => {
      isSubmit.value = true
      const isFormCorrect = await v$.value.$validate()
      // you can show some extra alert to the user or just leave the each field to show it's `$errors`.
      //jika error validasi

      if (!isFormCorrect) {
        isSubmit.value = false
        return;
      }

      // mapping data
      let data = {
        di_validasi_sensus: statusPersetujuan.value,
        di_validasi_sensus_note:
          statusPersetujuan.value === '1' ? '' : catatan.value,
        id_emp: g.$cookies.get('username'),
        id: props.id,
      }

      await dataInformasi.validasi(g, data)
      isSubmit.value = false
    };

    const getPdUkpd = async (searchPdUpd = '') => {
      let params = {
        tahun: tahunNow.value,
        cari: searchPdUpd,
      }
      let resPdUkpd = await master.getPdUpd(g, params)
      resPdUkpd.unshift({ text: '-- Pilih Salah Satu --', value: null })
      dataPdUkpd.value = resPdUkpd
      dataIndikasiGandaPdUkpd.value = resPdUkpd
    };

    const getCaraPerolehan = async () => {
      let resCaraPerolehan = await master.getCaraPerolehan(g)

      resCaraPerolehan.unshift({ text: '-- Pilih Salah Satu --', value: null })
      dataCaraPerolehanPenerimaan.value = resCaraPerolehan
    };

    getPdUkpd()
    getCaraPerolehan()

    const validateState = (item) => {
      const { $dirty, $error } = item
      return !$dirty ? null : $error ? false : null
    };

    const resetForm = () => {}

    return {
      v$,
      routeName,
      $externalResults,
      isSubmit,
      isShowInfo,
      kodeLokasi,
      kib,
      kodeBarang,
      namaBarang,
      satuan,
      kodeRegisterBarang,
      catatan,
      statusPersetujuan,
      nabar,
      nilaiPerolehan,
      tahunPerolehan,
      kesesuaianKodeBarang,
      kibSeharusnya,
      satuanSeharusnya,
      kodeBarangSeharusnya,
      namaBarangSeharusnya,
      ukuran,
      kesesuaianUkuran,
      ukuranSeharusnya,
      namaSpesifikasiBarang,
      caraPerolehanPenerimaan,
      isBertingkat,
      bertingkatSeharusnya,
      isLantaiDigunakan,
      jumlahSeluruhLantai,
      jumlahLantaiTidakDigunakan,
      jumlahLantaiDigunakan,
      jenisBeton,
      kesesuaianBahan,
      bahanSeharusnya,
      skPenggunaan,
      nomorSkPenggunaan,
      tahunSkPenggunaan,
      penggunaan,
      digunakanBersama,
      digunakanUntuk,
      pdUkpd,
      pemanfaat,
      gedungBangunanTanahMilik,
      isGedungBangunanTanahMilikTercatat,
      gedungBangunanTanahMilikPdUkpd,
      gedungBangunanTanahMilikKobar,
      gedungBangunanTanahMilikRegister,
      gedungBangunanTanahMilikKeterangan,
      gedungBangunanTanahMilikSebutkan,
      alamat,
      kesesuaianAlamat,
      provinsi,
      kabKota,
      kecamatan,
      kelurahan,
      jalan,
      noAlamat,
      rt,
      rw,
      kodePos,
      isIndikasiGanda,
      indikasiGandaDengan,
      indikasiGandaSebutkan,
      indikasiGandaPdUkpd,
      indikasiGandaKobar,
      indikasiGandaRegister,
      indikasiGabungan,
      indikasiGabunganKeterangan,
      isAtapBeton,
      isAtapBetonIsDigunakan,
      atapBetonDigunakan,
      isBasement,
      isBasementIsDigunakan,
      basementDigunakan,
      isHalamanUtama,
      isHalamanUtamaIsDigunakan,
      halamanUtamaDigunakan,
      nilaiStrategisBMD,
      memilikiNilaiStrategis,
      pengamananFisik,
      fisikDikuasai,
      fisikDikuasaiSebutkan,
      fisikTidakDikuasaiSebutkan,
      sengketaGedungBangunan,
      ketAsetBersejarah,
      dataKodeLokasi,
      dataKib,
      dataPdUkpd,
      dataIndikasiGandaPdUkpd,
      dataGedungBangunanTanahMilikRegister,
      dataProvinsi,
      dataKabKota,
      dataKecamatan,
      dataKelurahan,
      dataGedungBangunanTanahMilikKobar,
      dataIndikasiGandaRegister,
      dataKobar,
      dataCaraPerolehanPenerimaan,
      resetForm,
      validateState,
      submitForm,
    }
  },
  data() {
    return {
      dataPenggunaan: [
        { value: null, text: '-- Pilih Salah Satu --' },
        { value: '1', text: 'Tidak Digunakan' },
        { value: '2', text: 'Digunakan Sendiri Seluruhnya Oleh PD/UKPD' },
        { value: '3', text: 'Digunakan Seluruhnya Oleh PD/UKPD Lain' },
        {
          value: '4',
          text: 'Digunakan Bersama Oleh PD/UKPD Lain Dan/Atau Pihak Lain',
        },
        { value: '5', text: 'Digunakan Instansi/Pihak Lain Seluruhnya' },
      ],
      dataPemanfaat: [
        { value: null, text: '-- Pilih Salah Satu --' },
        { value: '1', text: 'Pemerintah Pusat' },
        { value: '2', text: 'Pemerintah Daerah Lainnya' },
        { value: '3', text: 'Pihak Lain Selain Pemerintah' },
      ],
      dataGedungBangunanTanahMilik: [
        { value: null, text: '-- Pilih Salah Satu --' },
        { value: '1', text: 'Pemerintah Daerah Provinsi DKI Jakarta' },
        { value: '2', text: 'Pemerintah Pusat' },
        { value: '3', text: 'Pemerintah Daerah Lain' },
        { value: '4', text: 'Pihak Lain' },
      ],
      dataIndikasiGandaDengan: [
        { value: null, text: '-- Pilih Salah Satu --' },
        { value: '1', text: 'Pemerintah Pusat' },
        { value: '2', text: 'Pemerintah Daerah Lain' },
        { value: '3', text: 'PD/UKPD' },
      ],
      dataNilaiStrategisBMD: [
        { text: '-- Pilih Salah Satu --', value: null },
        { value: '0', text: 'Tidak Memiliki Nilai Strategis' },
        { value: '1', text: 'Memiliki Nilai Strategis' },
      ],
    }
  },
  directives: {
    Ripple,
  },
  components: {
    vSelect,
    BCard,
    BForm,
    BFormRow,
    BCol,
    BFormInput,
    BFormValidFeedback,
    BFormInvalidFeedback,
    BCardHeader,
    BCardBody,
    BButton,
    BFormGroup,
    BCardTitle,
    BSpinner,
    BFormSelect,
    BTable,
    BRow,
    BFormTextarea,
  },
}
</script>

<style lang="scss" scope>
@import "@core/scss/vue/libs/vue-select.scss";
</style>